import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { SettingsPricesPage } from '@/features/settings/settings-page';

export const Route = createFileRoute('/_app/settings/prices')({
  component: () => (
    <RequireService service="SETTINGS_VIEW">
      <SettingsPricesPage />
    </RequireService>
  ),
});
